const initState = {
    crmPass: [],
    
    
  };
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default (state = initState, action) => {
    switch (action.type) {
      
      case "LOGINLEAD": {
        return {...state, crmPass:action?.payload }
      }    
      case "LOGOUT": {
  
        localStorage.clear()
        return {...state, crmPass:null }
         
          
        
      }
  
      
      default: {
        return state;
      }
    }
  };
  
  
  